import { UIFlightsInterlinkingInfo } from "@flights/types";

export type State = UIFlightsInterlinkingInfo | null;

export const getInitialState = (): State => null;
